import { controlledDevicesLeft, controlledDevicesRight } from '~/helpers/fields-description';
import { FieldObject } from '~/interfaces/field.interface';
import { WirelessSwitch } from '~/models/modules/legrand/WirelessSwitch.model';

export class WirelessSwitch2Buttons extends WirelessSwitch {

    get fieldControlledDevices(): FieldObject | undefined {
        return undefined;
    }
    get fieldControlledDevicesLeft(): FieldObject | undefined {
        return controlledDevicesLeft(this.controlledDevice(0));
    }
    get fieldControlledDevicesRight(): FieldObject | undefined {
        return controlledDevicesRight(this.controlledDevice(1));
    }
}
